import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {
  AccountCircle as AccountCircleIcon,
  Logout as LogoutIcon,
  Menu as MenuIcon,
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import homeIcon from '../assets/images/free-icon-home-1946436.png';
import sgsLogo from '../assets/images/sgs_logo.png';

interface HeaderProps {
  onSidebarToggle: () => void;
  sidebarOpen: boolean;
  appbarHeight: number;
}

const Header: React.FC<HeaderProps> = ({ onSidebarToggle, sidebarOpen, appbarHeight }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
    handleMenuClose();
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    handleMenuClose();
  };

  const initial =
    (user?.firstName?.trim?.().charAt(0) || user?.lastName?.trim?.().charAt(0) || user?.login?.trim?.().charAt(0) || '?')
      .toUpperCase();

  return (
    <AppBar
      position="sticky"
      sx={{
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: 'white',
        color: 'text.primary',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Toolbar sx={{ minHeight: appbarHeight }}>
        <IconButton
          color="inherit"
          aria-label="toggle sidebar"
          onClick={onSidebarToggle}
          sx={{ mr: 2 }}
        >
          <MenuIcon />
        </IconButton>

        <IconButton
          onClick={() => navigate('/dashboard')}
          sx={{ mr: 2 }}
        >
          <img
            src={homeIcon}
            alt="Home"
            style={{
              width: 24,
              height: 24,
              objectFit: 'contain',
            }}
          />
        </IconButton>

        <Box sx={{ flexGrow: 1 }} />

        <img
          src={sgsLogo}
          alt="Logo"
          style={{
            height: 40,
            width: 'auto',
            objectFit: 'contain',
            marginRight: 16,
            display: 'block',
            verticalAlign: 'middle',
          }}
        />

        {user && (
          <>
            <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} sx={{ ml: 1 }}>
              <Avatar 
                sx={{ 
                  width: 32, 
                  height: 32, 
                  background: '#CA4300',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  boxShadow: 'none',
                }}
              >
                {initial}
              </Avatar>
            </IconButton>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <MenuItem
                onClick={() => {
                  setAnchorEl(null);
                  handleLogout();
                }}
              >
                Logout
              </MenuItem>
            </Menu>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
